/* Listening drills, audio glossary, product mini-quiz and free-sample lead form.
   Markup is server-rendered (indexable); this script only adds checking, playback and form submission. */
(function () {
  "use strict";

  /* ---- Multiple-choice checking: any form[data-drill-form] holding fieldset.practice-q[data-answer] ---- */
  document.querySelectorAll("form[data-drill-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var qs = form.querySelectorAll("fieldset.practice-q");
      var right = 0, unanswered = 0;
      qs.forEach(function (fs) {
        var picked = fs.querySelector("input:checked");
        var answer = fs.getAttribute("data-answer");
        fs.querySelectorAll(".practice-option").forEach(function (opt, k) {
          opt.classList.toggle("is-answer", String(k) === answer);
        });
        fs.classList.remove("is-correct", "is-wrong");
        if (!picked) { unanswered++; return; }
        if (picked.value === answer) { right++; fs.classList.add("is-correct"); } else { fs.classList.add("is-wrong"); }
        var why = fs.querySelector(".practice-why");
        if (why) why.hidden = false;
      });
      var status = form.querySelector(".practice-status");
      if (unanswered) {
        if (status) status.textContent = "Answer every question first (" + unanswered + " left).";
        var first = form.querySelector("fieldset.practice-q:not(.is-correct):not(.is-wrong) input");
        if (first) first.focus();
        return;
      }
      if (status) status.textContent = right + " of " + qs.length + " correct." + (right < qs.length ? " Replay the recording and check the explanation." : "");
      var card = form.closest("[data-drill]");
      var tr = card && card.querySelector(".practice-transcript");
      if (tr) { tr.hidden = false; tr.open = true; }
      results.set(form, [right, qs.length]);
      updateScore();
      var after = form.querySelector("[data-quiz-after]");
      if (after) after.hidden = false;
      track("drill_check", { correct: right, total: qs.length, id: card ? card.id : "product-quiz" });
    });
  });

  /* ---- Page score (themed drill pages): sum of every checked drill ---- */
  var results = new Map();
  function updateScore() {
    var box = document.querySelector("[data-score]");
    if (!box) return;
    var total = +box.getAttribute("data-score-total") || 0, right = 0, done = 0, drills = 0;
    results.forEach(function (r) { right += r[0]; done += r[1]; drills++; });
    box.querySelector("[data-score-n]").textContent = right + " / " + total;
    var msg = done < total
      ? right + " correct out of " + done + " checked so far (" + drills + " drill" + (drills === 1 ? "" : "s") + "). Finish the rest for your full score."
      : (right === total ? "Every answer correct. Your ear is ready — now train the other five skills." : right / total >= 0.7 ? "Solid listening. Replay the drills you missed and read their transcripts aloud." : "Replay each recording with its transcript, then try again in a few days.");
    box.querySelector("[data-score-msg]").textContent = msg;
    box.classList.add("is-scored");
  }

  /* ---- One audio at a time across the page ---- */
  document.addEventListener("play", function (e) {
    document.querySelectorAll("audio").forEach(function (a) { if (a !== e.target) a.pause(); });
    if (player && e.target !== player) player.pause();
  }, true);

  /* ---- Glossary: shared player for play buttons + search filter ---- */
  var player = null, current = null;
  function setState(btn, on) {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.classList.toggle("is-playing", on);
    var lab = btn.querySelector(".gl-lab");
    if (lab) lab.textContent = on ? "Stop" : "Play";
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-play]");
    if (!btn) return;
    if (!player) {
      player = new Audio();
      player.preload = "none";
      player.addEventListener("ended", function () { if (current) setState(current, false); current = null; });
      player.addEventListener("error", function () {
        if (current) { setState(current, false); var lab = current.querySelector(".gl-lab"); if (lab) lab.textContent = "Unavailable"; }
        current = null;
      });
    }
    if (current === btn && !player.paused) { player.pause(); setState(btn, false); current = null; return; }
    if (current) setState(current, false);
    document.querySelectorAll("audio").forEach(function (a) { a.pause(); });
    current = btn;
    player.src = btn.getAttribute("data-play");
    setState(btn, true);
    var p = player.play();
    if (p && p.catch) p.catch(function () { if (current === btn) { setState(btn, false); current = null; } });
  });

  document.querySelectorAll("[data-sfp-glossary]").forEach(function (root) {
    var input = root.querySelector("[data-gl-search]");
    var count = root.querySelector("[data-gl-count]");
    var terms = root.querySelectorAll(".gl-term");
    if (!input) return;
    var t;
    input.addEventListener("input", function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var q = input.value.trim().toLowerCase(), shown = 0;
        terms.forEach(function (el) {
          var hit = !q || el.textContent.toLowerCase().indexOf(q) !== -1;
          el.hidden = !hit; if (hit) shown++;
        });
        root.querySelectorAll(".gl-group").forEach(function (g) {
          g.hidden = !g.querySelector(".gl-term:not([hidden])");
        });
        if (count) count.textContent = shown + (shown === 1 ? " term" : " terms") + (q ? " match “" + input.value.trim() + "”" : "");
      }, 120);
    });
  });

  /* ---- Lead form: POST {api}/api/leads {email, source, consent:true, meta} — 200 always means accepted (enumeration-safe) ---- */
  document.querySelectorAll("form[data-sample-form]").forEach(function (form) {
    var api = (form.getAttribute("data-api") || "").replace(/\/+$/, "");
    var status = form.querySelector("[data-sample-status]");
    var btn = form.querySelector("button[type=submit]");
    var email = form.querySelector("input[type=email]");
    var consent = form.querySelector("input[name=consent]");
    function say(msg, bad) { status.textContent = msg; status.classList.toggle("is-error", !!bad); }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var value = email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) { email.setAttribute("aria-invalid", "true"); say("Enter a valid email address, e.g. name@example.com.", true); email.focus(); return; }
      email.removeAttribute("aria-invalid");
      if (consent && !consent.checked) { say("Tick the box so we can email you the sample.", true); consent.focus(); return; }
      btn.disabled = true; btn.setAttribute("aria-busy", "true"); say("Sending…");
      var ctrl = "AbortController" in window ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
      fetch(api + "/api/leads", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: value, source: form.getAttribute("data-source") || "sample", consent: true, meta: { page: location.pathname } }),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        if (res.ok) {
          form.classList.add("is-sent");
          say(form.getAttribute("data-success") || "Thanks — if that address is valid, you will hear from us shortly. Check your inbox and the Promotions or Spam folder.");
          track("sample_lead", {});
          return;
        }
        if (res.status === 400) { say("That email address was not accepted. Check it and try again.", true); return; }
        if (res.status === 429) { say("Too many requests. Please try again tomorrow.", true); return; }
        throw new Error("HTTP " + res.status);
      }).catch(function () {
        say("We could not send the sample right now. Please try again in a few minutes, or contact us.", true);
      }).then(function () {
        clearTimeout(timer);
        btn.disabled = form.classList.contains("is-sent"); btn.removeAttribute("aria-busy");
      });
    });
  });

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (err) { /* analytics is optional */ }
  }
})();
